import { render } from "./VisitorDestinationColumn.vue?vue&type=template&id=399ab26a"
import script from "./VisitorDestinationColumn.vue?vue&type=script&lang=js"
export * from "./VisitorDestinationColumn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__